import React from "react";

const sizeClasses = {
  sm: "classnx-loader--sm",
  md: "classnx-loader--md",
  lg: "classnx-loader--lg",
};

const layoutClasses = {
  inline: "classnx-loader-wrap--inline",
  panel: "classnx-loader-wrap--panel",
  page: "classnx-loader-wrap--page",
};

export default function ClassNXLoader({
  label = "Loading",
  detail = "Please wait a moment.",
  size = "md",
  variant = "panel",
  showDocuments,
  showProgress,
  hideCopy = false,
  className = "",
}) {
  const isCompact = variant === "inline" || size === "sm";
  const renderDocuments = showDocuments ?? !isCompact;
  const renderProgress = showProgress ?? !isCompact;

  return (
    <div className={`classnx-loader-wrap ${layoutClasses[variant] || layoutClasses.panel} ${className}`} role="status" aria-live="polite">
      <div className={`classnx-loader-visual ${renderDocuments ? "classnx-loader-visual--scene" : ""}`} aria-hidden="true">
        {renderDocuments && ["one", "two", "three"].map((position) => (
          <span key={position} className={`classnx-logout-document classnx-logout-document--${position}`}>
            <i /><i /><i />
          </span>
        ))}
        <div className={`classnx-loader-mark ${sizeClasses[size] || sizeClasses.md}`}>
          <span className="classnx-loader-ring classnx-loader-ring--outer" />
          <span className="classnx-loader-ring classnx-loader-ring--inner" />
          <span className="classnx-loader-core">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" />
          </span>
        </div>
      </div>
      {!hideCopy && (
        <div className="classnx-loader-copy">
          <p>{label}</p>
          {detail && <span>{detail}</span>}
        </div>
      )}
      {renderProgress && <span className="classnx-logout-progress" aria-hidden="true"><i /></span>}
    </div>
  );
}
